// @flow @format
import React from 'react';
import DiskIcon from '../../../../components/Icon/hdd-o';
import {toSIString} from 'lib/util';
import {
	FileListBody,
	FileListItemRow,
	FileListItemLink,
	FileListItemCol,
} from '../../../../components/FileList';
import {encodeEmail} from 'lib/cloner-api/util';

import type {Repository} from 'lib/cloner-api';

type Props = {
	repositories: Repository[],
};

const RepositoryExplorer = ({repositories}: Props) =>
	<FileListBody>
		{repositories.map(repository =>
			<FileListItemRow key={repository.id}>
				<FileListItemCol>
					<DiskIcon className="FileList__Item__Icon" />
				</FileListItemCol>

				<FileListItemCol>
					<FileListItemLink
						to={`/explorer/files/${repository.id}/${repository.root}?userId=${encodeEmail(
							repository.owner
						)}&machineId=${repository.mid}`}
					>
						{repository.name.replace(/\\$/, '')}
					</FileListItemLink>
				</FileListItemCol>

				<FileListItemCol>
					{new Date(repository.last_backup).toLocaleDateString()}
				</FileListItemCol>

				<FileListItemCol>
					{new Date(repository.last_backup).toLocaleTimeString()}
				</FileListItemCol>

				<FileListItemCol>
					{toSIString(repository.disk_space)}
				</FileListItemCol>
			</FileListItemRow>
		)}
	</FileListBody>;

export default RepositoryExplorer;



// WEBPACK FOOTER //
// ./src/routes/Explorer/components/RepositoryExplorer/RepositoryExplorer.js